export default __webpack_public_path__ + "static/media/CareDrawer-min.21180b11.png";